import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "text-muted mt-2"
}
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "card shadow-sm mb-3" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "card shadow-sm mb-3" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table table-bordered text-center availability-heatmap" }
const _hoisted_18 = { class: "thead-dark" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "card shadow-sm mb-3" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_25 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_26 = { class: "table table-striped" }
const _hoisted_27 = { class: "card shadow-sm mb-3" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_30 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_31 = { class: "table table-striped" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = {
  key: 0,
  class: "badge bg-danger ms-1"
}
const _hoisted_34 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_35 = {
  key: 1,
  class: "badge bg-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[18] || (_cache[18] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "SP Availability"),
      _createElementVNode("p", null, [
        _createElementVNode("small", null, "Pick a partner and scenario to see when standardized patients actually have open time, and which requests are still open.")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          class: "border-0 text-secondary me-2",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query_partner) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPartnerChange && _ctx.onPartnerChange(...args)))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "Select Partner", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
            return (_openBlock(), _createElementBlock("option", {
              key: String(partner.id),
              value: partner.id
            }, _toDisplayString(partner.short_name), 9, _hoisted_3))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.query_partner]
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "border-0 text-secondary me-2",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query_scenario) = $event)),
          disabled: !_ctx.scenarios.length
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("option", { value: null }, "Select Scenario", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenario) => {
            return (_openBlock(), _createElementBlock("option", {
              key: String(scenario.id),
              value: scenario.id
            }, _toDisplayString(scenario.patient_name || scenario.title), 9, _hoisted_5))
          }), 128))
        ], 8, _hoisted_4), [
          [_vModelSelect, _ctx.query_scenario]
        ]),
        _createElementVNode("button", {
          class: "btn btn-lg btn-primary",
          disabled: !_ctx.query_partner || !_ctx.query_scenario,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generate()))
        }, "Generate", 8, _hoisted_6),
        (_ctx.query_partner && _ctx.scenarios_loaded && !_ctx.scenarios.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "There are no available scenarios for this partner."))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.has_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error_message), 1))
      : _createCommentVNode("", true),
    (_ctx.result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.result.program.partner_name) + " — " + _toDisplayString(_ctx.result.program.scenario_title), 1),
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createTextVNode("SPs assigned to this program: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.program.sp_count), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[7] || (_cache[7] = _createTextVNode("Open pending requests: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.open_request_count), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createTextVNode("Valid scheduling range: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.valid_range.effective_start || 'n/a') + " – " + _toDisplayString(_ctx.result.valid_range.effective_end || 'n/a'), 1),
                (_ctx.result.valid_range.partner_date_constrained)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (limited by partner scheduling dates)"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createTextVNode("All times shown in your time zone: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.timezone), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[13] || (_cache[13] = _createElementVNode("h5", null, "Weekly Availability Pattern", -1)),
              (!_ctx.rollupColumns.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.noDataReason), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("table", _hoisted_17, [
                        _createElementVNode("thead", _hoisted_18, [
                          _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayOrder, (weekday) => {
                              return (_openBlock(), _createElementBlock("th", { key: weekday }, _toDisplayString(weekday), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rollupColumns, (column) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: column.hour + '_' + column.minute
                            }, [
                              _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.formatTime(column.hour, column.minute)), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayOrder, (weekday) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: weekday,
                                  style: _normalizeStyle(_ctx.cellStyle(weekday, column))
                                }, _toDisplayString(_ctx.rollupValue(weekday, column)), 5))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-muted mt-2" }, [
                      _createElementVNode("small", null, "Darker cells = more standardized patients available on average. Each cell averages that exact half-hour slot across the valid range, so fractional values (e.g. 1.5) are expected — they mean availability varies across the weeks that share that slot, not that \"half an SP\" is free.")
                    ], -1)),
                    (_ctx.generalRecommendedWindows.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                            _createElementVNode("strong", null, "General recommended windows")
                          ], -1)),
                          _createElementVNode("ul", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalRecommendedWindows, (window, ind) => {
                              return (_openBlock(), _createElementBlock("li", { key: ind }, _toDisplayString(window.weekday) + " between " + _toDisplayString(_ctx.formatTime(window.startHour, window.startMinute)) + " - " + _toDisplayString(_ctx.formatTime(window.endHour, window.endMinute)), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Recommended Redirect Windows", -1)),
              (!_ctx.result.recommended_windows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.noDataReason), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", { class: "thead-dark" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Date"),
                          _createElementVNode("th", null, "Weekday"),
                          _createElementVNode("th", null, "Time"),
                          _createElementVNode("th", null, "Available SPs"),
                          _createElementVNode("th", null, "Current Demand")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.recommended_windows, (slot, ind) => {
                          return (_openBlock(), _createElementBlock("tr", { key: ind }, [
                            _createElementVNode("td", null, _toDisplayString(slot.date), 1),
                            _createElementVNode("td", null, _toDisplayString(slot.weekday), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.moment.parseZone(slot.start_time).format('h:mm a')), 1),
                            _createElementVNode("td", null, _toDisplayString(slot.available_sp_count), 1),
                            _createElementVNode("td", null, _toDisplayString(slot.requested_demand_count), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[17] || (_cache[17] = _createElementVNode("h5", null, "Open Requests", -1)),
              (!_ctx.result.open_requests.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "No open requests for this program."))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("table", _hoisted_31, [
                      _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "thead-dark" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Learner"),
                          _createElementVNode("th", null, "Days Pending"),
                          _createElementVNode("th", null, "Originally Requested (your time)"),
                          _createElementVNode("th", null, "Requester's Local Time"),
                          _createElementVNode("th", null, "SP Available?")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.open_requests, (req) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: req.request_id
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, _toDisplayString(req.user ? req.user.name : 'Unknown'), 1),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("small", null, _toDisplayString(req.user ? req.user.email : ''), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDaysPending(req.days_pending)), 1),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.originally_requested_dates, (date, ind) => {
                                return (_openBlock(), _createElementBlock("div", { key: ind }, [
                                  _createTextVNode(_toDisplayString(_ctx.moment.parseZone(date.start_time_your_tz).format('dddd MM/DD/YY h:mm a')) + " ", 1),
                                  (date.outside_current_partner_range)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, "outside current range"))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.originally_requested_dates, (date, ind) => {
                                return (_openBlock(), _createElementBlock("div", { key: ind }, _toDisplayString(_ctx.moment.parseZone(date.start_time).format('dddd MM/DD/YY h:mm a')) + " (" + _toDisplayString(date.timezone) + ") ", 1))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.originally_requested_dates, (date, ind) => {
                                return (_openBlock(), _createElementBlock("div", { key: ind }, [
                                  (date.sp_available_count > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Yes (" + _toDisplayString(date.sp_available_count) + ")", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_35, "No"))
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}